export const NOT_SURE_CAPTION =
  "That's okay. Many families start here, and you can update this whenever you learn more.";

export function getFirstName(fullName: string): string {
  return fullName.split(" ")[0] ?? "";
}

export function getLastName(fullName: string): string {
  return fullName.split(" ").slice(1).join(" ");
}

export function setFirstName(fullName: string, first: string): string {
  return `${first} ${getLastName(fullName)}`.trim();
}

export function setLastName(fullName: string, last: string): string {
  return `${getFirstName(fullName)} ${last}`.trim();
}
